<template>
	<component :is="type" v-bind="{tag, mode, appear}" v-on="{beforeEnter, enter, leave}">
		<slot></slot>
	</component>
</template>

<script>
	export default {
		props: {
			tag: {
				default: null
			},
			mode: {
				default: null
			},
			direction: {
				default: 'up'
			},
			duration: {
				default: () => ({
					enter: 250,
					leave: 250
				})
			},
			displacement: {
				default: () => ({
					enter: 100,
					leave: 20
				})
			},
			appear: {
				default: null
			}
		},
		computed: {
			type: function () {
				return this.tag === null ? 'transition' : 'transition-group';
			}
		},
		methods: {
			beforeEnter: function (el) {
				this.$velocity(el, {
					opacity: 0,
					translateY: '100px'
				}, {
					duration: 0
				});
			},
			enter: function (el, done) {
				this.$velocity(el, {
					opacity: 1,
					translateY: '0px'
				}, {
					duration: this.duration.enter,
					complete: function () {
						done();
					}
				});
			},
			leave: function (el, done) {
				this.$velocity(el, {
					opacity: 0,
					translateY: '100px'
				}, {
					duration: this.duration.leave,
					complete: function () {
						done();
					}
				});
			}
		}
	}
</script>

<style lang="scss">

</style>